
const tltAttr = 'title';
const tltPosAttr = 'data-tooltip-pos';
let updateTooltip = (coll) => {
  coll.each((item) => {
    var attrs = item.get('attributes');
    attrs[tltPosAttr] = 'bottom';
    item.set('attributes', attrs);
  });
}

export default function(opt = {}) {
  let editor = opt.editor;
  let pnm = editor.Panels;
  pnm.addButton('options', {
    id: opt.cmdOpenImport,
    className: 'fa fa-download',
    command: opt.cmdOpenImport,
    attributes: {[tltAttr]: opt.modalTitleImport},
  });
  pnm.addButton('options', {
    id: opt.cmdTglImages,
    className: 'fa fa-warning',
    command: opt.cmdTglImages,
    attributes: {[tltAttr]: opt.cmtTglImagesLabel},
  });
  let optPanel = pnm.getPanel('options');
  if(optPanel){
    // Fix tooltip position
    var cmdBtns = optPanel.get('buttons');
    cmdBtns.each((btn) => {
      var attrs = btn.get('attributes');
      attrs[tltPosAttr] = 'bottom';
      btn.set('attributes', attrs);
    });
    // Remove preview
    // let prvBtn = pnm.addButton('options', 'preview');
    // prvBtn && cmdBtns.remove(prvBtn);

    cmdBtns.add([{
      id: 'undo',
      className: 'fa fa-undo',
      command: 'undo',
      attributes: {[tltAttr]: opt.cmdBtnUndoLabel}
    },{
      id: 'redo',
      className: 'fa fa-repeat',
      command: 'redo',
      attributes: {[tltAttr]: opt.cmdBtnRedoLabel}
    },{
      id: 'save',
      className: 'fa fa-save',
      command: 'save-document',
      attributes: {[tltAttr]: 'Sauvegarder'}
    },
    // {
    //   id: 'subject',
    //   command: 'set-device-mobile',
    //   tagName: 'input',
    //   className: 'fa fa-mobile',
    //   attributes: {[tltAttr]: opt.cmdBtnMobileLabel},
    // },
    {
      id: 'close',
      className: 'fa fa-times',
      command: 'close',
      attributes: {[tltAttr]: 'Fermer'}
    }

    ]);

  }
  // Clean commands panel
  let cmdPanel = pnm.getPanel('commands');
  // console.log('cmdPanel', cmdPanel)

  if(cmdPanel){
    let cmdBtns = cmdPanel.get('buttons');
    cmdBtns.reset();
    // cmdBtns.add([{
    //   id: 'subject',
    //   command: 'set-device-mobile',
    //   tagName: 'input',
    //   className: 'fa fa-mobile',
    //   attributes: {[tltAttr]: opt.cmdBtnMobileLabel},
    // }]);
    // updateTooltip(cmdBtns);
  }
  // Turn off default devices select and create new one

  editor.getConfig().showDevices = 0;
  let devicePanel = pnm.addPanel({
    id: 'devices-c'
  });

  // let messsage_subject = editor.vueEl.subject

  let deviceBtns = devicePanel.get('buttons');
  devicePanel.get('buttons').add([{
    id: 'deviceDesktop',
    command: 'set-device-desktop',
    className: 'fa fa-desktop',
    attributes: {[tltAttr]: opt.cmdBtnDesktopLabel},
    active: 1,
  }, {
    id: 'deviceTablet',
    command: 'set-device-tablet',
    className: 'fa fa-tablet',
    attributes: {[tltAttr]: opt.cmdBtnTabletLabel},
  }, {
    id: 'deviceMobile',
    command: 'set-device-mobile',
    className: 'fa fa-mobile',
    attributes: {[tltAttr]: opt.cmdBtnMobileLabel},
  },
  {
      id: 'subject',
      command: 'nada',
      tagName: 'input',
      className: 'messsage-subject-input',
      attributes: {
        [tltAttr]: opt.cmdBtnMobileLabel,
        id: "gjs-messsage-subject-input",
        // value: messsage_subject
      },
    }
  ])
  updateTooltip(deviceBtns);
  // console.log('devicePanel', devicePanel)
  //let viewPanel = pnm.getPanel('views');
  //viewPanel && updateTooltip(viewPanel.get('buttons'));
};
